import React, { CSSProperties, FC } from "react";
import ReactLoading from "react-loading";
import colors from "constants/colors";

interface IProps {
  showSpinner: boolean;
  style?: CSSProperties;
  className?: string;
  color?: string;
  info?: string;
}

const Spinner: FC<IProps> = ({ showSpinner, style, className, color, info }) => {
  return (
    showSpinner && (
      <div className={`local-spinner ${className || ""}`} style={style}>
        <ReactLoading type="spin" color={color || colors.grey} height={50} width={50} />
        {info && <div className="spinner-text">{info}</div>}
      </div>
    )
  );
};

export default Spinner;
